import { isEmpty } from 'ts/login/services/input';
import { validEmail } from '@origin-digital/validation';

const getUsernameValidationError = (username: string): string | void => {
  if (isEmpty(username)) {
    return 'Please enter an email.';
  }
  return validEmail({ error: "Oops, that doesn't look like an email address." })(username);
};

const getPasswordValidationError = (password: string): string => {
  if (isEmpty(password)) {
    return 'Please enter a password.';
  } else {
    return undefined;
  }
};

export { getUsernameValidationError, getPasswordValidationError };
